export function getParameterFromURL(name) {
  var url = window.location.href;
  var regex = new RegExp("[?&]".concat(name.replace(/[[\]]/g, '\\$&'), "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}